import React from "react";
import styled from 'styled-components';
import magnifying from '../../../img/svg/magnifying-glass.svg';
import {
  RequestsFilterCard,
  RequestsFilterForm,
  RequestsSearchFieldGroup,
  RequestsDateFieldGroup,
} from '../../../components/Header/Search/searchFilterToolbar.styles';
import {
  DateInput as HeaderDateInput,
  DateContainerInput as HeaderDateContainerInput,
  FilterIcon as HeaderFilterIcon,
  FilterInput as HeaderFilterInput,
  FilterButton as HeaderFilterButton,
  FilterText as HeaderFilterText,
} from '../../../components/Header/Search/SearchStyles';

export const ContainerInput = styled.div`
  width: 17vw;

  &:after {
    content: url(${magnifying});
    width: .5rem;
    height: .5rem;
    position: absolute;
    left: 60%;
  }
`;

export const Input = styled.input`
  width: 100%;
  outline-width: 0;
  font-size: .9rem;
  font-family: 'Open Sans';
  background: transparent;
  border: transparent;
  border-bottom: 1px solid ${props => props.theme['color_border-gray-secondary']};
  padding-left: 8px;
  color: ${props => props.theme.color_gray};

  &:focus {
    background: ${props => props.theme.color_white};
  }
`;

export const DateInput = HeaderDateInput;

export const DateContainerInput = styled(HeaderDateContainerInput)``;

export const FilterContainerInput = styled.div`
  width: 100%;
  min-width: 0;
  display: inline-block;
`;

export const FilterIcon = HeaderFilterIcon;

export const FilterInput = HeaderFilterInput;

export const FilterButton = HeaderFilterButton;
export const FilterText = HeaderFilterText;

export const ChargeFilterCard = styled(RequestsFilterCard)``;

export const ChargeFilterForm = styled(RequestsFilterForm)``;

export const ChargeSelectFieldGroup = styled(RequestsSearchFieldGroup)`
  flex: 0 0 164px;
  max-width: 164px;
  min-width: 148px;
`;

export const ChargeFilterTypeSegment = styled.div`
  display: none;
  width: 100%;
  gap: 6px;

  @media (max-width: 800px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

export const ChargeFilterTypeSegmentButton = styled.button`
  border: 1px solid ${props => props.active ? '#152b4e' : 'rgba(21, 43, 78, 0.18)'};
  background: ${props => props.active ? 'linear-gradient(180deg, #1f3f71 0%, #16355f 100%)' : '#f8f9fb'};
  color: ${props => props.active ? '#fff' : '#5f6f85'};
  border-radius: 8px;
  min-height: 34px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const ChargeSearchFieldGroup = styled(RequestsSearchFieldGroup)`
  flex: 1 1 240px;
  max-width: 280px;
  min-width: 150px;
`;

export const ChargeDateFieldGroup = styled(RequestsDateFieldGroup)`
  flex: 1 1 auto;
  min-width: 0;
`;

export const ChargeFilterTypeSelect = styled.select`
  width: 100%;
  height: 34px;
  border: 1px solid rgba(21, 43, 78, 0.12);
  border-radius: 8px;
  background: #f8f9fb;
  color: #5f6f85;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.01em;
  padding: 0 9px;
  outline: none;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;

  &:focus {
    border-color: #152b4e;
    box-shadow: 0 0 0 3px rgba(21, 43, 78, 0.1);
    background: #fff;
  }

  @media (max-width: 800px) {
    display: none;
  }
`;

export const ChargeFilterSubmitButton = styled(FilterButton)`
  margin-left: 0 !important;
  flex-shrink: 0;
`;

export const ChargeFilterCardMobileFix = styled.div`
  @media (max-width: 800px) {
    ${ChargeFilterCard} {
      padding: 12px 12px 10px;
    }

    ${ChargeFilterForm} {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }

    ${ChargeSelectFieldGroup},
    ${ChargeSearchFieldGroup},
    ${ChargeDateFieldGroup} {
      width: 100%;
      max-width: none;
      min-width: 0;
      flex: 1 1 auto;
    }

    ${ChargeDateFieldGroup} {
      display: grid;
      grid-template-columns: auto auto minmax(0, 1fr) auto minmax(0, 1fr);
      gap: 6px 8px;
      align-items: center;
    }

    ${ChargeDateFieldGroup} ${FilterIcon} {
      margin-right: 0 !important;
    }

    ${ChargeDateFieldGroup} ${DateContainerInput} {
      width: 100% !important;
      max-width: none !important;
      min-width: 0 !important;
    }

    ${ChargeDateFieldGroup} button[type='submit'] {
      grid-column: 1 / -1;
      width: 100%;
      margin-left: 0 !important;
      margin-top: 4px;
    }
  }
`;